import { action } from 'typesafe-actions';
import type { IDocument } from '../senderBuild/types';
import type { ITemplateRecipient, ITemplate, ITemplateCreateState } from './template-types';

export enum ActionTypes {
  RESET = 'templateCreate/RESET',
  API_ERROR = 'templateCreate/API_ERROR',
  FETCH_TEMPLATE = 'templateCreate/FETCH_TEMPLATE',
  FETCH_TEMPLATE_DONE = 'templateCreate/FETCH_TEMPLATE_DONE',
  UPDATE_TEMPLATE = 'templateCreate/UPDATE_TEMPLATE',
  UPDATE_TEMPLATE_DONE = 'templateCreate/UPDATE_TEMPLATE_DONE',
  UPLOAD_DOCUMENT = 'templateCreate/UPLOAD_DOCUMENT',
  UPLOAD_DOCUMENT_DONE = 'templateCreate/UPLOAD_DOCUMENT_DONE',
  ADD_RECIPIENT = 'templateCreate/ADD_RECIPIENT',
  UPDATE_RECIPIENT = 'templateCreate/UPDATE_RECIPIENT',
  UPDATE_RECIPIENT_DONE = 'templateCreate/UPDATE_RECIPIENT_DONE',
  CHANGE_RECIPIENT_TITLE = 'templateCreate/CHANGE_RECIPIENT_TITLE',
  DELETE_DOCUMENT = 'templateCreate/DELETE_DOCUNENT',
  REORDER_DOCUMENTS = 'templateCreate/REORDER_DOCUMENTS',
  UPDATE_DOCUMENTS = 'templateCreate/UPDATE_DOCUMENTS',
  DELETE_RECIPIENT = 'templateCreate/DELETE_RECIPIENT',
  DELETE_RECIPIENT_DONE = 'templateCreate/DELETE_RECIPIENT_DONE',
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const reset = (newStore?: ITemplateCreateState) => action(ActionTypes.RESET, newStore);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const apiError = (error?: string) => action(ActionTypes.API_ERROR, error);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTemplate = (templateId: string) => action(ActionTypes.FETCH_TEMPLATE, templateId);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTemplateDone = (template: ITemplate) => action(ActionTypes.FETCH_TEMPLATE_DONE, template);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateTemplate = (patchBody: Partial<ITemplate>) => action(ActionTypes.UPDATE_TEMPLATE, patchBody);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateTemplateDone = (template: ITemplate) => action(ActionTypes.UPDATE_TEMPLATE_DONE, template);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const uploadDocument = (tempId: string, file: File) => action(ActionTypes.UPLOAD_DOCUMENT, { tempId, file });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const uploadDocumentDone = (tempId: string, document: IDocument) =>
  action(ActionTypes.UPLOAD_DOCUMENT_DONE, { tempId, document });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const addRecipient = (recipient: ITemplateRecipient) => action(ActionTypes.ADD_RECIPIENT, recipient);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateRecipient = (recipientId: string, update: Partial<ITemplateRecipient>) =>
  action(ActionTypes.UPDATE_RECIPIENT, { recipientId, update });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateRecipientDone = (recipientId: string, recipient: ITemplateRecipient) =>
  action(ActionTypes.UPDATE_RECIPIENT_DONE, { recipientId, recipient });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const changeRecipientTitle = (recipientId: string, title: string) =>
  action(ActionTypes.CHANGE_RECIPIENT_TITLE, { recipientId, title });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const deleteDocument = (documentId: string) => action(ActionTypes.DELETE_DOCUMENT, documentId);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const reorderDocuments = (documents: IDocument[]) => action(ActionTypes.REORDER_DOCUMENTS, documents);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateDocuments = (documents: IDocument[]) => action(ActionTypes.UPDATE_DOCUMENTS, documents);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const deleteRecipient = (templateId: string, recipient: ITemplateRecipient) =>
  action(ActionTypes.DELETE_RECIPIENT, { templateId, recipient });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const deleteRecipientDone = (recipientId: string) => action(ActionTypes.DELETE_RECIPIENT_DONE, recipientId);
